import React from 'react';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = ({
  palette: {
    common: { black },
  },
  custom: {
    palette: { colorSupportPowder },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    filterBadge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: unit * 4,
      height: unit * 3,
      color: black,
      backgroundColor: colorSupportPowder,
      fontSize: 12,
      textTransform: 'capitalize',
      lineHeight: 1,
      fontWeight: 500,
      borderRadius: 3,
    },
  });

type DivProps = JSX.IntrinsicElements['div'];
export interface FilterBadgeProps extends WithStyles<typeof styles>, DivProps {
  badge: any;
}

const FilterBadge: React.FC<FilterBadgeProps> = ({ classes, badge }) => (
  <div className={classes.filterBadge}>{badge > 99 ? '99+' : badge}</div>
);

export default withStyles(styles)(FilterBadge);
